<template>
    <div style="text-align: left">
        <div class="herd">
            <div class="list">负责人管理</div>
        </div>

        <div class="content">
            <div class="goods">
                <div>
                    <div class="condition">
                        开始时间：<el-date-picker v-model="info.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                            format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
                        &nbsp;&nbsp;
                        结束时间：<el-date-picker v-model="info.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                            format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
                        &nbsp;&nbsp;
                        负责人：<el-input v-model="info.person" placeholder="请输入负责人"></el-input>
                        <el-button style="margin-left:20px" type="primary" plain @click="getUserInfo">搜 索</el-button>
                        <!--  <el-button style="margin-left:20px" type="primary" @click="resetList" plain>重 置</el-button> -->
                    </div>
                    <hr style="margin-top: 20px" />
                </div>
                <br />
            </div>
            <br />
            <!-- <div @click="export2Excel">导出表格</div> -->
            <div class="global-table-box">
                <div class="table-html-wrap" v-html="tableHtml"></div>
            </div>
        </div>
    </div>
</template>

<script>
import request from '../utils/request';
import { read, utils } from 'xlsx'
// import axios from 'axios';
// import exportUrl from '../Api/exportUrl'
export default {

    data() {
        return {
            // exportUrl,
            // 查询参数
            info: {
                endTime: "",
                person: "",
                startTime: ""
            },
            tableHtml: null

        };
    },
    created() {
    },
    mounted() {

    },

    methods: {
        // 重置查询
        // resetList() {
        //     this.info.province = null
        //     this.info.city = null
        //     this.info.area = null
        //     this.info.isPage = true
        //     this.info.pageSize = 10
        //     this.info.pageNum = 1
        //     this.info.schoolName = ''
        //     this.info.detailedArea = []
        // },
        async getUserInfo() {
            // console.log(XLSX);
            if (this.info.endTime != '' && this.info.person != '' && this.info.startTime != '') {
                const res = await request({
                    url: 'admin/order/export/person',
                    method: "POST",
                    responseType: 'arraybuffer',
                    data: this.info
                })
                try {
                    let ect = new TextDecoder('utf-8')
                    let val = JSON.parse(ect.decode(new Uint8Array(res)))
                    // console.log(val);
                    this.$message.error(val.message)
                } catch (_) {
                    let data = new Uint8Array(res)
                    let html = read(data, {
                        type: 'array'
                    })
                    this.tableHtml = utils.sheet_to_html(html.Sheets[html.SheetNames[0]])
                }
            } else {
                this.$message.error('请填写正确的查询条件')
            }

            // console.log(res);

            // console.log(val.code === void 0, res.code, void 0, val);
            // if (val.code === void 0) {
            //     let data = new Uint8Array(res)
            //     let html = read(data, {
            //         type: 'array'
            //     })
            //     console.log(utils.sheet_to_html);
            //     this.tableHtml = utils.sheet_to_html(html.Sheets[html.SheetNames[0]])
            // } else {
            //     console.log(1);
            // }
            // console.log(res.SheetNames);
            // // this.tableHtml = XLSX.utils.sheet_to_html(res)
            // this.tableHtml = utils.sheet_to_html(res)
            // console.log(this.tableHtml.SheetNames);
        }



    },
    watch: {
    }
};
</script>

<style lang="scss" scoped>
.list {
    background-color: #2589ff;
    color: #fff;
    text-align: center;
    width: 106px;
    height: 36px;
    margin-right: 10px;
    font-size: 16px;
    line-height: 36px;
    display: inline-block;
    border-radius: 6px;
}

.content {
    margin: 20px 0 0 0;
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 5px;
}

.goods {
    background-color: #fff;
    border-radius: 5px;
    padding: 10px 20px;
}

.gross-container {
    width: 300px;
    height: 100px;
    background-color: #000;
    text-align: center;
    padding: 20px 0;
    color: #fff;
}

.condition {
    display: flex;
    line-height: 30px;
}

.herd {
    display: flex;
    justify-content: space-between;
}

.block {
    text-align: right;
    background-color: #fff;
}


.el-input {
    width: 200px;
}

.input-with-select .el-input-group__prepend {
    background-color: #fff;
}


.table-html-wrap {
    // background-color: #000;
    // height: 1000px;
}

.table-html-wrap::v-deep table {
    border-right: 1px solid #e8eaec;
    border-bottom: 1px solid #e8eaec;
    border-collapse: collapse;
    margin: auto;
}

.table-html-wrap::v-deep table td {
    border-left: 1px solid #e8eaec;
    border-top: 1px solid #e8eaec;
    white-space: nowrap;
    text-align: center;
    padding: .5rem;
}

.table-html-wrap::v-deep tbody tr:nth-of-type(1) {
    font-weight: bold;
    font-size: 20px;
}
</style>